import type { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  icon: ReactNode;
  /** Sin datos en el rango: se dice, en vez de dibujar ejes vacíos. */
  empty?: boolean;
  children: ReactNode;
}

export function ChartCard({ title, icon, empty = false, children }: ChartCardProps) {
  return (
    <div className="dashboard-page__chart-card">
      <div className="dashboard-page__chart-header">
        <h2 className="dashboard-page__chart-title">{icon}{title}</h2>
      </div>
      {empty ? <p className="dashboard-stats__empty">Sin datos en este periodo.</p> : children}
    </div>
  );
}

interface StatTileProps {
  label: string;
  value: string | number;
  hint?: string;
}

/** Cifra resumen de una pestaña. Más liviana que `KpiCard`: los KPIs de flota ya ocupan la fila de arriba. */
export function StatTile({ label, value, hint }: StatTileProps) {
  return (
    <div className="dashboard-stats__tile">
      <span className="dashboard-stats__tile-label">{label}</span>
      <span className="dashboard-stats__tile-value">{value}</span>
      {hint && <span className="dashboard-stats__tile-hint">{hint}</span>}
    </div>
  );
}
